import {messages} from './../messages.js'
import axios from "axios";

// получить инфу корзины
const setCartItems = async ({commit, getters}) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        axios
            .get('/rest/cart')
            .then((response) => {
                commit('SET_CART_ITEMS', response.data.items)

                commit('SET_CART_COUNT', response.data.count)

                commit('SET_CART_SUMM', response.data.summ)

                commit('SET_PC_DISCOUNT', response.data.pc_discount)

                commit('SET_PC_CODE', response.data.pc_code)

                commit('SET_USER_ID', response.data.user_id)

                commit('SET_DELIV_REGION_ID', response.data.region_id)

                commit('SET_DELIV_CITY_ID', response.data.city_id)

                commit('SET_DELIV_COUNTRY', response.data.country)
                commit('SET_DELIV_REGION', response.data.region)
                commit('SET_DELIV_CITY', response.data.city)
                commit('SET_DELIV_ZIP', response.data.zip)
                commit('SET_DELIV_TYPE_ID', response.data.delivery_type_id)
                commit('SET_REQUIRE_ADDRESS', response.data.require_address)

                // if cart is empty, reload page
                if(getters.change_cart && getters.cartcount==0) {
                    //location.reload();
                }

                commit('SET_CHANGED_CART', false)

                commit('setLoading', false)
            });

    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }

}

// удалить элемент из корзины
const removeItem = async({commit, dispatch}, item_id) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        // кидаем евент
        dispatch('deleteFromBasketEvent',{item_id})
        let params = {
            cart_item_id: item_id
        }
        let param = yii.getCsrfParam();
        let token = yii.getCsrfToken();
        params[param] = token;
        axios
            .delete('/rest/cart', {
                data: params
            })
            .then(() => {
                commit('SET_CHANGED_CART', true)
                dispatch('setCartItems')
                commit('setLoading', false)
                Evnt.fire('SomethingChangedInCart');
            })
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
}

// изменение кол-ва товара в корзине
const changeProductQty = async ({commit, dispatch}, {qty, cart_item_id}) => {
    commit('clearError')
    commit('setLoading', true)

    let params = {
        qty: qty,
        cart_item_id: cart_item_id,
        action: 'change_item'
    }

    let param = yii.getCsrfParam();
    let token = yii.getCsrfToken();
    params[param] = token;

    axios.put('/rest/cart', params)
        .then((response) => {
            if(response.data.qty) {
                commit('SET_CHANGED_CART', true)
                dispatch('setCartItems')
                // кидаем евент
                dispatch('changeBasketEvent',{cart_item_id:cart_item_id,qty:qty})

                Evnt.fire('SomethingChangedInCart');
            } else {
                messages.methods.notify(response.data.message, 'error', 1000);
            }

            commit('setLoading', false)

        })
        .catch(error => {
            commit('setLoading', false)
            commit('setError', error.message)
            throw error
        })

}

const changeProductService = async ({commit, dispatch}, {price, prop, cart_item_id}) => {
    commit('clearError')
    commit('setLoading', true)

    let params = {
        price: price,
        qty: 1,
        prop: prop,
        cart_item_id: cart_item_id,
        action: 'change_service_item'
    }

    let param = yii.getCsrfParam();
    let token = yii.getCsrfToken();
    params[param] = token;

    axios.put('/rest/cart', params)
        .then((response) => {
            if(response.data.qty) {
                commit('SET_CHANGED_CART', true)
                dispatch('setCartItems')

            } else {
                messages.methods.notify(response.data.message, 'error', 1000);
            }

            commit('setLoading', false)

        })
        .catch(error => {
            commit('setLoading', false)
            commit('setError', error.message)
            throw error
        })

}

// добавить товар в корзину
const addProduct = async ({commit, dispatch}, {product_id, qty, variant_id, bundle_id}) => {
    commit('clearError')
    commit('setLoading', true)

    let params = new URLSearchParams();
    params.append('product_id', product_id);
    params.append('qty', qty);
    params.append('variant_id', variant_id);
    params.append('bundle_id', bundle_id);

    let param = yii.getCsrfParam();
    let token = yii.getCsrfToken();
    params.append(param, token);

    axios.post('/rest/cart', params)
        .then((response) => {
            commit('SET_CHANGED_CART', true)
            dispatch('setCartItems')
            let product = response.data.product

            // кидаем евент
            dispatch('addToBasketEvent', {
                product_id: product_id,
                sku: product.sku,
                name: product.name,
                qty: qty,
                price: product.price,
                variant_id: variant_id
            })

            Evnt.fire('SomethingChangedInCart');

            // выводим сообщение
            if(response.data.success) {
                //messages.methods.notify(response.data.message, 'success', 1000);
            } else {
                messages.methods.notify(response.data.message, 'error', 0);
            }

        })
        .catch(error => {
            commit('setLoading', false)
            commit('setError', error.message)
            throw error
        })

}

const addBundle = ({commit, dispatch}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    let params = new URLSearchParams();
    params.append('items', JSON.stringify(payload));
    let param = yii.getCsrfParam();
    let token = yii.getCsrfToken();
    params.append(param, token);

    axios.post('/rest/cart', params)
        .then((response) => {
            commit('SET_CHANGED_CART', true)
            dispatch('setCartItems')
            Evnt.fire('SomethingChangedInCart');

            // выводим сообщение
            if(response.data.success) {
                //messages.methods.notify(response.data.message, 'success', 1000);
            } else {
                messages.methods.notify(response.data.message, 'error', 0);
            }
        })
        .catch(error => {
            commit('setLoading', false)
            commit('setError', error.message)
            throw error
        })
}

// применить промокод
const applyPromocode = ({commit, dispatch}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    try {

        let params = new URLSearchParams();
        params.append('prom_code', payload);

        axios
            .post('/rest/promo', params)
            .then((response) => {

                commit('SET_CHANGED_CART', true)
                dispatch('setCartItems')

                commit('setLoading', false)

                if(response.data.error) {
                    messages.methods.notify(response.data.message, 'error', 1000);
                }
            })
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
}

// отменить промокод
const disablePromocode = ({commit, dispatch}) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        axios
            .delete('/rest/promo')
            .then(() => {
                commit('SET_CHANGED_CART', true)
                dispatch('setCartItems')
                commit('setLoading', false)
            })
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
}

export default {
    setCartItems,
    removeItem,
    changeProductQty,
    changeProductService,
    addProduct,
    addBundle,
    applyPromocode,
    disablePromocode
}
